import utils from '@eitje/utils'
import {formatCssVars, makeCnVariants} from '../../../../helpers'
import {Layout} from '../../../layout'
import {CollapseChevron} from '../../../collapse_chevron'
import {useAdvancedTableRoleMessage} from './role_check'
import './styles/index.less'
import {CellCheckbox, TableText} from './components'
import {CollapsibleCell} from './collapsible'
import {GROUPED_CELL_WIDTH, DEFAULT_CELL_WIDTH} from '../../constants'
import {getLeftOffset, isLastPinnedColumn, getPinnedColumns} from '../../helpers'
import {renderCell} from './helpers'

export * from './constants'
export * from './components'
export * from './cells'
export * from './collapsible'
export * from './helpers'
export * from './role_check'

export const AdvancedTableCell = ({row, cell, index, multiAction, getRowDisabled}) => {
	const {column, getContext} = cell
	const {id: columnName, getIsPinned, getIsGrouped, columnDef} = column
	const {getIsExpanded, getCanExpand, subRows} = row
	const isGroupedColumn = getIsGrouped()
	const canExpand = getCanExpand()
	const context = getContext()
	const disabled = useAdvancedTableRoleMessage(cell)
	const styles = formatCssVars({'left-offset': getLeftOffset(index, context)})
	const lastPinned = isLastPinnedColumn(index, context)
	const showCollapseChevron = isGroupedColumn && canExpand
	const pinnedColumns = getPinnedColumns(context)
	const withCheckbox = multiAction?.enabled && pinnedColumns[0] === columnName
	const classNames = utils.makeCns(
		makeCnVariants('advanced-table-body-cell', getIsPinned() && 'pinned', lastPinned && 'last-pinned', disabled && 'disabled'),
		columnName,
	)
	cell.hasSubRows = utils.exists(subRows)

	const layoutProps = {
		height: 32,
		padding: 8,
		width: columnDef.width || (isGroupedColumn ? GROUPED_CELL_WIDTH : DEFAULT_CELL_WIDTH),
		horizontal: showCollapseChevron && 'last-item-end',
	}

	let content
	if (disabled) {
		content = '?'
	} else if (canExpand) {
		content = <CollapsibleCell isGroupedColumn={isGroupedColumn} row={row} cell={cell} />
	} else {
		content = <TableText>{renderCell(cell)}</TableText>
	}

	return (
		<Layout className={classNames} key={cell.id} {...layoutProps} style={styles} disabled={disabled}>
			{withCheckbox && <CellCheckbox row={row} cell={cell} multiAction={multiAction} getRowDisabled={getRowDisabled} />}
			{content}
			{showCollapseChevron && <CollapseChevron open={getIsExpanded()} />}
		</Layout>
	)
}
